export class SecretModel {
  isNew!: boolean
  name!: string
  contentType!: string
  value!: string
  tags: any
}
